<template>
  <div>
    <el-card v-loading="loading" class="box-card" :body-style="{
      height: '400px',
      overflow: 'auto',
      display: ProjectIcon ? 'none' : '',
    }">
      <div slot="header" class="clearfix">
        <span style="font-size: 16px">选择计划：</span>

        <el-select filterable v-model="planName" placeholder="计划选择" @change="planChange">
          <el-option v-for="item in options" :key="item.pjpl01" :label="item.pjpl03" :value="item.pjpl01"></el-option>
        </el-select>

        <el-button @click="exportExcel" class="but-prople">导出报表</el-button>
        <el-button type="primary" @click="SetHomeIcon" :icon="ProjectIcon ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">{{
          ProjectIcon ? "展开" : "关闭" }}</el-button>
      </div>
      <div class="card-top">
        <span style="color: deepskyblue">{{ $store.state.xidName }}</span>
        <span style="color: deepskyblue" v-if="data.planInfo.pjpl03">&nbsp;&nbsp;{{ data.planInfo.pjpl03
        }}&nbsp;&nbsp;</span>
        <span>施工进度表</span>
      </div>
      <!-- 表格部分 -->
      <table class="table" border="1" cellspacing="0" width="100%" height="380">
        <tr>
          <th colspan="3">整体进度：{{ data.planInfo.wcjd ? data.planInfo.wcjd.toFixed(2) + "%" : '' }}</th>
          <th colspan="5">
            重要程度：{{ data.planInfo.pjpl05
            }}<el-rate v-model="data.planInfo.pjpl05" disabled></el-rate>
          </th>
          <th colspan="3">总负责人：{{ data.planInfo.user04 }}</th>
          <th colspan="3">报表日期：{{ new Date().toLocaleDateString() }}</th>
        </tr>
        <tr>
          <td>序号</td>
          <td colspa="4">任务名称</td>
          <td>当前状态</td>
          <td>延期天数</td>
          <td>完成进度</td>
          <td>计划工期天数</td>
          <td>计划占比</td>
          <td>计划开始</td>
          <td>计划结束</td>
          <td>实际工期天数</td>
          <td>实际开始</td>
          <td>实际完成</td>
          <td>责任人</td>
          <td>相关人</td>
        </tr>
        <tr v-for="(item, index) in data.plandetailList" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.pldt04 }}</td>
          <td>{{ item.State }}</td>
          <td>{{ item.ExtensionDays }}</td>
          <td>{{ item.CompletionSchedule.toFixed(1) }}%</td>
          <td>{{ item.PlanDays }}</td>
          <td>{{ item.pldt05 }}</td>
          <td>{{ item.pldt06 }}</td>
          <td>{{ item.pldt07 }}</td>
          <td>{{ item.RealDays }}</td>
          <td>{{ item.pldt08 }}</td>
          <td>{{ item.pldt09 }}</td>
          <td>{{ item.pldt12 }}</td>
          <td>{{ item.pldt13 }}</td>
        </tr>
        <tr>
          <td rowspan="2">备注:</td>
          <td rowspan="2" colspan="13">{{ data.planInfo.pjpl06 }}</td>
        </tr>
      </table>
    </el-card>
    <!-- 模型部分 -->
    <div style="padding: -30px">
      <iframe :src="src" width="100%" :height="ModelHeight" frameborder="0" ref="iframeref"></iframe>
    </div>
  </div>
</template>

<script>
import { GetPlanListNoJd } from "@/setAxios";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  data() {
    return {
      src: window.location.origin + "/#/trueProgressModel",
      ModelHeight: document.body.clientHeight - 90,
      data: {
        planInfo: {
          pjpl05: 0,
          wcjd: 0,
          pjpl03: "",
          user04: "",
          pjpl03: "",
          pjpl05: 0,
        },
        plandetailList: [],
      },
      ProjectIcon: false,
      loading: false,
      planName: "",
      options: [],
    };
  },
  mounted() {
    this.GetPlanListNoJd();
  },
  methods: {
    SetHomeIcon() {
      this.ProjectIcon = !this.ProjectIcon;
    },
    GetPlanListNoJd() {
      let params = {
        xid: localStorage.xid,
        userid: localStorage.id,
      };
      GetPlanListNoJd(params).then((res) => {
        this.options = res.Data;
        this.planName = res.Data[0].pjpl01;
        this.$refs.iframeref.onload = () => {
          this.$refs.iframeref.contentWindow.postMessage(
            {
              options: res.Data,
              planName: res.Data[0].pjpl01,
            },
            "*"
          );
        };
      });
    },
    planChange(data) {
      this.planName = data;
      this.loading = true;
      this.$refs.iframeref.contentWindow.postMessage(
        {
          planName: data,
        },
        "*"
      );
    },
    // 导出表格所用
    exportExcel() {
      let name =
        this.$store.state.xidName +
        " " +
        this.data.planInfo.pjpl03 +
        " 施工进度表-" +
        new Date().format("yyyyMMddhhmmss");
      var wb = XLSX.utils.table_to_book(document.querySelector(".table"));
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        //  name+'.xlsx'表示导出的excel表格名字
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {
        // if (typeof console !== "undefined") //(e, wbout);
      }
      return wbout;
    },
  },
  created() {
    this.loading = true;
    // 接收iframe传参
    window.addEventListener(
      "message",
      (event) => {
        if (event.data.hasOwnProperty("data")) {
          this.data = event.data.data;
          this.loading = false;
        }
      },
      false
    );
  },
};
</script>

<style lang="less" scoped>
.box-card {
  margin-bottom: 10px;

  .but-prople {
    margin-left: 40px;
    background-color: #6084fd;
    color: white;
  }

  .card-top {
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 5px;
  }

  td {
    text-align: center;
    font-weight: bold;
  }

  th {
    padding-left: 25px;
  }
}
</style>
